import Vue from "vue";
import axios from 'axios';

const version = 'v1';
const getAllCountriesByNameApi = `${version}/BasicData/countries`;
const getAllFirmTypesApi = `${version}/BasicData/firmTypes`;
const getAllFirmSizesApi = `${version}/BasicData/firmSizes`;
const getAllChargeCyclesApi = `${version}/BasicData/getAllChargeCycles`;
const getAllAddonBillingTypesApi = `${version}/BasicData/getAllAddonBillingTypes`;
const getAllUnitsApi = `${version}/BasicData/getAllUnits`;

export const state = Vue.observable({
	countries: [],
	firmTypes: [],
	firmSizes: [],
	chargeCycles: [],
	addonBillingTypes: [],
});

export const mutations = {
	async setCountries() {
		var res = await axios.get(getAllCountriesByNameApi);
		state.countries = res.data.result;
	},
	async getCountries() {
		if (state.countries.length == 0) { await this.setCountries(); }
		return state.countries;
	},
	async setFirmTypes() {
		var res = await axios.get(getAllFirmTypesApi);
		state.firmTypes = res.data.result;
	},
	async getFirmTypes() {
		if (state.firmTypes.length == 0) { await this.setFirmTypes(); }
		return state.firmTypes;
	},
	async setFirmSizes() {
		var res = await axios.get(getAllFirmSizesApi);
		state.firmSizes = res.data.result;
	},
	async getFirmSizes() {
		if (state.firmSizes.length == 0) { await this.setFirmSizes(); }
		return state.firmSizes;
	},
	async getChargeCycles() {
		var res = await axios.get(getAllChargeCyclesApi);
		state.chargeCycles = res.data.result;
	},
	async getAddonBillingTypes() {
		var res = await axios.get(getAllAddonBillingTypesApi);
		state.addonBillingTypes = res.data.result;
	},
	async getAllUnits() {
		var res = await axios.get(getAllUnitsApi);
		state.units = res.data.result;
	}
};
